<template>
    <div class="tabBox">
        <div class="tabContainer" :class="{'content':!mobileHeader,'mobileContent':mobileHeader }">
          <img id="logoImg" :src="logoUrl" />
          <ul class="topTab flexBox">
            <el-row class="menu-items" style="width:100%;">
              <el-col :span="4">
                <div  class="menu-item" :class="{'menu-item-select':bannerSelTag}" @click="goPart('banner-part')">首页</div>
              </el-col>
              <el-col :span="4">
                <div  class="menu-item" :class="{'menu-item-select':solutionSelTag}" @click="goPart('solution-part')">解决方案</div>
              </el-col>
              <el-col :span="4">
                <div  class="menu-item" :class="{'menu-item-select':newsSelTag}" @click="goPart('news-part')">新闻动态</div>
              </el-col>
              <el-col :span="4">
                <div  class="menu-item" :class="{'menu-item-select':ecologySelTag}" @click="goPart('ecology-part')">生态优势</div>
              </el-col>
              <el-col :span="4">
                <div  class="menu-item" :class="{'menu-item-select':aboutSelTag}" @click="goPart('about-part')">关于我们</div>
              </el-col>
              <el-col :span="4">
                <div  class="menu-item" :class="{'menu-item-select':contactSelTag}" @click="goPart('contact-me')">联系我们</div>
              </el-col>
            </el-row>
          </ul>
        </div>
      </div>
</template>
<script>
export default {
  name: 'Mybottom',
  props: {
    pageType: {
      type: String,
      default: 'Home'
    },
    selectIndex: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      mobileHeader: false,
      bannerSelTag: true,
      solutionSelTag: false,
      newsSelTag: false,
      ecologySelTag: false,
      aboutSelTag: false,
      contactSelTag: false,
      logoUrl: require('../../../static/images/logo.png')
    }
  },
  mounted () {
    if (navigator.userAgent.match(/mobile/i)) {
      this.mobileHeader = true
    }
  },
  created () {
    var protocol = window.location.protocol
    var hostname = window.location.hostname
    var port = window.location.port
    this.apiUrl = protocol + '//' + hostname + ':' + port
    this.bannerSelTag = false
    this.solutionSelTag = false
    this.newsSelTag = false
    this.ecologySelTag = false
    this.aboutSelTag = false
    this.contactSelTag = false
    switch (this.selectIndex) {
      case 1 :
        this.bannerSelTag = true
        break
      case 2 :
        this.solutionSelTag = true
        break
      case 3 :
        this.newsSelTag = true
        break
      case 4 :
        this.ecologySelTag = true
        break
      case 5 :
        this.aboutSelTag = true
        break
      case 6 :
        this.contactSelTag = true
        break
      default:break
    }
  },
  methods: {
    goPart (partId) {
      if (this.pageType !== 'Home') {
        this.$emit('goHome', partId)
      } else {
        this.bannerSelTag = false
        this.solutionSelTag = false
        this.newsSelTag = false
        this.ecologySelTag = false
        this.aboutSelTag = false
        this.contactSelTag = false
        switch (partId) {
          case 'solution-part':
            this.solutionSelTag = true
            break
          case 'news-part':
            this.newsSelTag = true
            break
          case 'ecology-part':
            this.ecologySelTag = true
            break
          case 'about-part':
            this.aboutSelTag = true
            break
          case 'contact-me':
            this.contactSelTag = true
            break
          default :
            this.bannerSelTag = true
            break
        }
        document.getElementById(partId).scrollIntoView({
          block: 'start',
          behavior: 'smooth'
        })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.tabBox{
    width: 100%;
    height: 70px;
    background-color: #fff;
    cursor: pointer;
  }
  .content{
    width: 65%;
    margin: auto;
    position: relative;
  }
  .mobileContent{
    width: 100VW;
  }
  .mobileContent #logoImg{
    margin-left: 15px;
  }
  .pageBox .content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    opacity: 1;
    color: black;
  }
  .tabContainer{
    display: flex;
    align-items: center;
    height: 100%;
    justify-content: space-between;
  }
  .topTab{
    width: 62%;
    justify-content: flex-end;
  }
  .topTab li{
    width: 16.7%;
    cursor: pointer;
    text-align: center;
  }
  .topTab li span{
    color: #4E4E4E;
    height: 80px;
    font-size: 16px;
  }
  .topTab li.active span{
    color: #0065F3;
    font-weight: 700;
    /* border-bottom: 3px solid #0065F3; */
    display: inline-block;
    line-height:80px;
  }
  .logo .logo-img{
    text-align: center;
    padding: 15px 0px;
  }
   .menu-items{
    width: 60%;
    line-height: 50px;
    cursor: pointer;
  }
  .menu-items .menu-item{
    padding-top: 5px;
    font-size: 16px !important;
    color: grey;
    cursor: pointer;
  }
  .menu-item-select{
    color: #0451db !important;
    font-weight: 700;
  }
</style>



// WEBPACK FOOTER //
// src/components/pageHeader/header.vue